/* Settings ▸ Permit Library ▸ Permit Row Colors — API calls (PermitRowColorsController). */
import { api } from '../../../api/client';
import { PERMIT_ROW_COLORS_URL } from '../../analysis/permitRowColors';
import type { RowColorRule } from '../../analysis/permitRowColorState';

/** One condition as the page sends it: limit-type Oids, or "MDL". */
export interface RowColorConditionInput { op: string; match: 'any' | 'all'; limits: string[] }

/** A rule as the page sends it. */
export interface RowColorRuleInput {
  name: string;
  color: string;
  isActive: boolean;
  conditions: RowColorConditionInput[];
}

/** Creates a rule; returns it as saved (with its id), so the detail can stay on it. */
export async function createRowColorRule(input: RowColorRuleInput): Promise<RowColorRule> {
  const res = await api.post(PERMIT_ROW_COLORS_URL, input);
  return res.data.data as RowColorRule;
}

/** Updates a rule; returns it as saved. */
export async function updateRowColorRule(id: string, input: RowColorRuleInput): Promise<RowColorRule> {
  const res = await api.put(`${PERMIT_ROW_COLORS_URL}/${id}`, input);
  return res.data.data as RowColorRule;
}

export async function deleteRowColorRule(id: string): Promise<void> {
  await api.delete(`${PERMIT_ROW_COLORS_URL}/${id}`);
}

export async function moveRowColorRule(id: string, direction: -1 | 1): Promise<void> {
  await api.post(`${PERMIT_ROW_COLORS_URL}/${id}/move`, null, { params: { direction } });
}

/** The server's refusal message (400 / 403 / 404 / 409), when there is one. */
export function rowColorRefusal(e: unknown): string | undefined {
  const data = (e as { response?: { data?: { error?: { message?: string }; message?: string } } })?.response?.data;
  return data?.error?.message ?? data?.message ?? undefined;
}
